export default {
  hd: 'Disponible en HD, Haute Définition',
  'hd-2': 'Disponible en HD, Haute Définition',
  vostfr: 'Disponible en VOST, Version Originale Sous-Titrée',
  'vostfr-vf': 'VOST/VF,disponible en Version Originale Sous-Titrée et Version Française',
  vf: 'Disponible en VF, Version Française',
  vm: 'Disponible en VM, Version Multilingue',
  'hearing-impaired': 'Sous titrage pour malentendant disponible',
  'hearing-impaired-2': 'Sous titrage pour malentendant disponible',
  'audio-description': 'Disponible en AD, Audio Description',
  'audio-description-2': 'Disponible en AD, Audio Description',
  'audio-description-3': 'Disponible en AD, Audio Description',
  'csa-round2': 'Déconseillé aux moins de 10 ans',
  csa2: 'Déconseillé aux moins de 10 ans',
  'csa-round3': 'Déconseillé aux moins de 12 ans',
  csa3: 'Déconseillé aux moins de 12 ans',
  'csa-round4': 'Déconseillé aux moins de 16 ans',
  csa4: 'Déconseillé aux moins de 16 ans',
  'csa-round5': 'Déconseillé aux moins de 18 ans',
  csa5: 'Déconseillé aux moins de 18 ans'
}
